export const publicMemberKeys = {
    all: ['publicMember'] as const,
    list: (centerId: string) => [...publicMemberKeys.all, 'list', centerId] as const,
    detail: (centerId: string, memberId: string) =>
        [...publicMemberKeys.all, 'detail', centerId, memberId] as const,
};
